import { Component, Prop, Vue } from 'vue-property-decorator';
import ClListItem from '../ClListItem';

type Value =
  | string
  | number
  | boolean
  | object
  | string[]
  | number[]
  | boolean[]
  | object[];

@Component({
  components: {
    ClListItem
  }
})
export default class ClMenuItem extends ClListItem {
  @Prop({
    type: Boolean,
    default: false
  })
  public button!: boolean;

  @Prop({
    type: String,
    default: 'li'
  })
  public component!: string;

  @Prop({
    type: String,
    default: 'menuitem'
  })
  public role!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  public selected!: boolean;

  @Prop({
    type: [String, Number, Boolean, Object, Array]
  })
  public value!: Value;

  handleClick(event: Event) {
    this.$emit('click', event, this);
  }
}
